module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "surveillance-biology"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.biologyInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "130"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.label) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Organism",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "Not Selected"
          }
        }, _vm._l((_vm.organisms), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.name,
              "value": item.id
            }
          }, [_c('span', {
            staticStyle: {
              "float": "left"
            }
          }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
            staticStyle: {
              "float": "right",
              "color": "#8492a6",
              "font-size": "13px"
            }
          }, [_vm._v(_vm._s(item.value))])])
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Antibiotic Sensitivity"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "Not Selected"
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b8384a7!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SurveillanceBiology.vue
// module id = 248
// module chunks = 2